import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

class PolicyPage extends React.Component {
  render() {
    return (
      <Layout>
        <SEO />
        <div className="policy">
          <section>
            <div className="container is-slim">
              <div className="mt-40 has-text-centered">
                <h2 className="title is-2">PICKSプライバシーポリシー</h2>
              </div>
              <div className="mt-40 mlr-20-mobile">
                <div>
                  <div>1. 適用範囲</div>
                  <div className="ma-10">
                    このプライバシーポリシーは株式会社DIRIGIO（以下「当社」といいます）が提供するサービス「PICKS（ピックス）」(以下「本サービス」といいます）を利用するお客様（以下「お客様」といいます）の個人情報等の取り扱いについて定めたものです。当社とお客様との間で、お客様の個人情報等の取り扱いについて別段の合意がある場合には当該合意が優先されます。このプライバシーポリシーに別段の定めのない限り、このプライバシーポリシーで用いる用語は、当社が本サービスの利用に関して別途定める「PICKS利用規約（ユーザー）」及び「PICKS利用規約（事業者）」に定義する意味を有するものとします。
                  </div>
                </div>
                <div>
                  <div>2. 関係法令・ガイドライン等の遵守</div>
                  <div className="ma-10">
                    当社は、個人情報の保護に関する法律（以下「個人情報保護法」といいます）その他の関係法令、個人情報保護委員会の定めるガイドライン等及び本ポリシーを遵守し、個人情報（個人情報保護法第2条第1項により定義された個人情報をいいます。以下同じ）を適法かつ適正に取り扱います。
                  </div>
                </div>
                <div>
                  <div>3. 取得方法及び取得情報</div>
                  <div className="ma-10">
                    ① お客様から直接取得する情報
                    <br />
                    お客様が本サービスの利用登録手続を行う際、以下の情報をご提供いただく場合があります。
                    <br />
                    ・本サービスを利用して商品を購入するお客様：氏名 ・メールアドレス ・電話番号・デリバリー先の住所・プロフィール画像・プロフィール情報
                    <br />
                    ・本サービスを利用して商品を販売するお客様：担当者名 ・口座情報 ・その他当社が指定する情報
                    <br />
                    ②お客様が他のサービス（Facebook等）との連携を許可することにより、当該他のサービスから取得する情報
                    <br />
                    お客様が本サービスを利用するにあたり、Facebook等の外部サービスとの連携を許可した場合には、その許可の際にご同意いただいた内容に基づき、以下の情報を当該外部サービスからご提供いただく場合があります。
                    <br />
                    ・お客様が、外部サービスとの連携を許可する際に、当該外部サービス又は当社からお客様に明示した情報
                    <br />
                    ③お客様が本サービスを利用するにあたって、当社が取得する情報
                    <br />
                    お客様が、本サービスを利用するにともない、以下の情報を自動的に取得する場合があります。
                    <br />
                    ・端末情報
                    <br />
                    お客様がスマートフォンやタブレット（以下「利用端末」といいます。）上で本サービスを利用する場合、利用端末の端末情報（端末識別子、IPアドレス等）を取得する場合があります。
                    <br />
                    ・位置情報
                    <br />
                    お客様がスマートフォンやタブレット上で本サービスを利用し、そこで位置情報を提供することに同意した場合、当社はお客様の現在地に関する情報を取得することがあります。
                    <br />
                    ・本サービスの利用履歴・取引履歴
                    <br />
                    ④支払情報
                    <br />
                    お客様が、本サービスを利用する際にPSPによって支払いが処理される場合、お客様からPSPに提供された支払情報を当社が取得する場合があります。
                  </div>
                </div>
                <div>
                  <div>4. 取得した情報の利用目的</div>
                  <div className="ma-10">
                    当社は、取得したお客様の情報を以下の目的で利用します。
                    <br />
                    ・本サービスを提供するため
                    <br />
                    ・本サービスに関する各種事項の連絡や情報提供を行うため
                    <br />
                    ・売買代金等の決済・請求・支払のため
                    <br />
                    ・ お問い合わせ・アフターサービス対応のため
                    <br />
                    ・キャンペーン・懸賞企画、アンケートの実施のため
                    <br />
                    ・当社、販売者、その他の第三者の商品又はサービスの広告、宣伝（電子メールによるものを含みます）のため
                    <br />
                    ・マーケティング調査、統計、分析のため
                    <br />
                    ・本サービスの最適化・改善、新商品・新サービス・新規事業の開発のため
                    <br />
                    ・本サービス運営上のトラブルの解決のため
                    <br />
                    ・上記の利用目的に付随する利用目的のため
                    <br />
                  </div>
                </div>
                <div>
                  <div>5. 個人情報利用の制限</div>
                  <div className="ma-10">
                    当社は、お客様から同意を得た場合又は法令上要求もしくは許容される場合を除き、利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。
                  </div>
                </div>
                <div>
                  <div>6. 個人情報の安全管理</div>
                  <div className="ma-10">
                    ①当社は、お客様の個人情報につき、利用目的の達成に必要な範囲において、正確かつ最新の内容に保つとともに、利用する必要がなくなったときは当該個人情報を消去するよう努めます。
                    <br />
                    ②当社は、お客様の個人情報の紛失、破壊、改ざん及び漏洩などのリスクに対して、個人情報の安全管理が図られるよう、必要かつ適切な措置を講じます。
                    <br />
                    ③当社は、お客様の個人情報を従業員に取り扱わせるにあたっては、個人情報の安全管理が図られるよう、個人情報の適正な取扱いを周知徹底するとともに、適正な教育を行い、必要かつ適切な監督を行います。
                  </div>
                </div>
                <div>
                  <div>7. 情報の取り扱いの委託</div>
                  <div className="ma-10">
                    当社は利用目的の達成に必要な範囲内においてお客様から取得した情報（個人情報を含みます）の取り扱いを業務委託先に委託することがあります。その際、業務委託先としての適格性を十分審査し、お客様の情報が適切に取り扱われるよう業務委託先を管理します。
                  </div>
                </div>
                <div>
                  <div>8. 個人情報の第三者提供</div>
                  <div className="ma-10">
                    当社は、以下の場合を除いて、お客様の個人情報を第三者に提供することはありません。
                    <br />
                    ①商品売買契約の履行に必要な範囲で、販売者、デリバリー業者、PSPに、お客様の氏名、住所、電話番号等を提供する場合
                    <br />
                    ②お客様から同意を得た場合
                    <br />
                    ③　法令上要求又は許容される場合
                  </div>
                </div>
                <div>
                  <div>9. 個人情報の開示・修正・利用停止</div>
                  <div className="ma-10">
                    当社は、お客様から、個人情報保護法の定めに基づき個人情報の開示、訂正、追加又は削除、利用の停止又は消去（以下「開示等」といいます。）を求められた場合、当社所定の方法によりお客様ご本人からの請求であることを確認したうえで、遅滞なく開示等を行います。ただし、個人情報保護法その他の法令により、当社が開示等の義務を負わない場合はこの限りではありません。なお、個人情報の開示等につきましては、手数料（1件あたり1,500円）を頂戴しておりますので、あらかじめ御了承ください。
                  </div>
                </div>
                <div>
                  <div>10. お問い合わせ</div>
                  <div className="ma-10">
                    お客様の情報の取り扱いに関する苦情、その他のお問い合わせは、当社が別途指定しない限り、以下のメールアドレスによるものとします。
                    <br />
                    ・飲食物の注文者として本サービスを利用するお客様：
                    <br />
                    customer@picks.fun
                    <br />
                    ・登録飲食店として本サービスを利用するお客様：
                    <br />
                    restaurant@picks.fun
                  </div>
                </div>
                <div>
                  <div>11. プライバシーポリシーの改定</div>
                  <div className="ma-10">
                    当社は、必要に応じ、あらかじめお客様に通知することなく、プライバシーポリシーを変更することができます。変更後のプライバシーポリシーは、本サービスのウェブサイトに 掲載された時点から適用され、お客様はその後、本サービスを利用した場合、変更後のプライバシーポリシーに同意したものとみなされます。プライバシーポリシーの変更内容に同意できない場合は、本サービスの利用を中止してください。
                  </div>
                </div>
              </div>
              <div className="ma-10">会社名：株式会社DIRIGIO</div>
              <div className="ma-10">所在地：東京都目黒区上目黒3-6-18 西村ビル7階</div>
              <div className="ma-10">最終更新日：2021年06月24日</div>
            </div>
          </section>
        </div>
      </Layout>
    )
  }
}

export default PolicyPage
